<div
    *ngIf="slug"
    class="flex flex-shrink-0 items-center gap-2.5 border-b border-amber-300 bg-amber-100 px-4 py-1.5 text-sm text-amber-950 md:px-6 print:hidden"
    role="status"
    data-testid="uat-banner"
>
    <span class="min-w-0 flex-1">
        <b>{{ "uatBanner.title" | transloco: { slug: slug } }}</b>
        {{ "uatBanner.body" | transloco }}
    </span>
</div>
